import { api } from "@/services/api";

export const algoManagementApi = api.injectEndpoints({
    endpoints: (builder) => ({
        // Fetch Strategy Instances
        fetchStrategyInstances: builder.query<any, void>({
            query: () => "/api/algo/v1/strategy_instance_status",
        }),

        // Fetch Strategy Definitions
        fetchStrategies: builder.query<any, void>({
            query: () => "/api/algo/v1/strategy",
        }),

        // Fetch RPCs
        fetchInteractions: builder.query<any, void>({
            query: () => "/api/algo/v1/interaction",
        }),

        // Submit RPC (result is backend response object, e.g. { result?: string | object })
        submitRpc: builder.mutation<Record<string, unknown>, { data: any }>({
            query: ({ data }) => ({
                url: `/api/algo/v1/interaction`,
                method: "POST",
                body: data,
            }),
        }),
    }),
});

export const {
    useFetchStrategyInstancesQuery,
    useFetchStrategiesQuery,
    useFetchInteractionsQuery,
    useSubmitRpcMutation,
} = algoManagementApi;
